// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const nav = useNavigate();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await loginWithGoogleSession(sessionId);
        // Strip the fragment and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        nav("/dashboard", { replace: true });
      } catch (e) {
        const msg = formatApiError(e.response?.data?.detail) || "Google sign-in failed";
        setErr(msg);
        // Give the user a moment to read, then bounce to login
        setTimeout(() => nav(`/login?err=${encodeURIComponent(msg)}`, { replace: true }), 1500);
      }
    })();
  }, [loginWithGoogleSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="max-w-sm w-full text-center" data-testid="auth-callback">
        {err ? (
          <>
            <div className="heading text-lg font-semibold text-rose-700 mb-2">Sign-in blocked</div>
            <div className="text-sm text-slate-600">{err}</div>
          </>
        ) : (
          <>
            <div className="w-10 h-10 mx-auto mb-3 border-4 border-emerald-200 border-t-emerald-700 rounded-full animate-spin" />
            <div className="text-sm text-slate-600">Signing you in with Google…</div>
          </>
        )}
      </div>
    </div>
  );
}
